function convertArrayToDictionary(arr, defaultValue = null) {
    const dictionary = {};
    arr.forEach(element => {
        dictionary[element] = defaultValue;
    });
    return dictionary;
}

export { convertArrayToDictionary }